//will track the cards that are not played yet
let yetToPlay = {};

export let setYetToPlay = () => {
  //console.log("yetToPlay has been reset");
  yetToPlay = {
    hearts: ["jack", "nine", "ace", "ten", "king", "queen", "eight", "seven"],
    spades: ["jack", "nine", "ace", "ten", "king", "queen", "eight", "seven"],
    diamonds: ["jack", "nine", "ace", "ten", "king", "queen", "eight", "seven"],
    clubs: ["jack", "nine", "ace", "ten", "king", "queen", "eight", "seven"],
  };
};

export let nextPlayer = (now) => {
  let next = "";
  switch (now) {
    case "south":
      next = "east";
      break;
    case "east":
      next = "north";
      break;
    case "north":
      next = "west";
      break;
    case "west":
      next = "south";
      break;
    default:
      //console.log("now is wrong");
      break;
  }
  //console.log("we looked the next play of " + now + " and found " + next);
  return next;
};

export let prevPlayer = (now) => {
  let prev = "";
  switch (now) {
    case "south":
      prev = "west";
      break;
    case "east":
      prev = "south";
      break;
    case "north":
      prev = "east";
      break;
    case "west":
      prev = "north";
      break;
    default:
      //console.log("now is wrong");
      break;
  }
  //console.log("we looked the prev play of " + now + " and found " + prev);
  return prev;
};

export let frontPlayer = (now) => {
  let front = "";
  switch (now) {
    case "south":
      front = "north";
      break;
    case "east":
      front = "west";
      break;
    case "north":
      front = "south";
      break;
    case "west":
      front = "east";
      break;
    default:
      //console.log("now is wrong");
      break;
  }
  //console.log("we looked the prev play of " + now + " and found " + front);
  return front;
};

export let getscore = (bet) => {
  let points = 0;
  switch (bet) {
    case 150:
      points = 1;
      break;
    case 170:
      points = 1.5;
      break;
    case 200:
      points = 2;
      break;
    case 250:
      points = 3;
      break;
    case 304:
      points = 4;
      break;
    default:
      //console.log("bet is wrong");
      break;
  }
  /*console.log(
    "we looked the score to add for the bet: " + bet + " and found: " + points
  );*/
  return points;
};

export let cleanTable = (player = "south") => {
  //console.log("we cleand the table for player : " + player);
 
  return {
    

    cards: {
      south: { src: "../img/blue3.png", alt: "empty" },
      east: { src: "../img/red3.png", alt: "empty" },
      north: { src: "../img/blue3.png", alt: "empty" },
      west: { src: "../img/red3.png", alt: "empty" },
    },
    totalCardsInTable: 0,
    firstCardPlayed: {},
    firstPlayer: player,
    nextPlayer: player,
  };
};

export let getTopCard = (suit) => {
  //console.log(yetToPlay[suit]);
  return yetToPlay[suit][0];
};

export let cleanHands = {
  south: [],
  east: [],
  north: [],
  west: [],
};

export let cleanGame = {
  trumpSuit: "",
  pointsWon: 0,
  pointsLost: 0,
  bet: 0,
  round: 0,
  better: "None",
};

export let cleanScore = {
  us: 0,
  them: 0,
};

export let deleteCardInYetTOPlay = (suit, rank) => {
  //console.log("delete :" + suit + " " + rank);
  yetToPlay[suit] = yetToPlay[suit]?.filter((element) => {
    return element !== rank;
  });
  //console.log(yetToPlay);
};

export let findWinner = (trump, suit, cards) => {
  let winData = {
    winner: "",
    points: 0,
  };
  //console.log("the card to judge" + JSON.stringify(cards));
  //console.log("the trump is: " + trump);

  let hasTrump = Object.values(cards).some((e) => e?.suit === trump);
  let tempsPoint = -1;

  //console.log("the player has trump : " + hasTrump);

  for (const key in cards) {
    winData.points = winData.points + cards[key]?.points;
    //deleteCardInYetTOPlay(cards[key].suit, cards[key].rank);

    if (hasTrump) {
      //console.log(cards[key]?.suit === trump, cards[key]?.points > tempsPoint);

      if (cards[key]?.suit === trump && cards[key]?.points > tempsPoint) {
        tempsPoint = cards[key]?.points;
        //console.log("the actual winner is " + key + " he has played trump");
        winData.winner = key;
      }
    } else {
      if (cards[key]?.suit === suit && cards[key]?.points > tempsPoint) {
        tempsPoint = cards[key]?.points;
        //console.log("the actual winner is " + key);
        winData.winner = key;
      }
    }
  }
  /*
  console.log(
    "the table winner is " +
      winData.winner +
      " our team gains :" +
      winData.points
  );
  */
  return winData;
};

export let getName = (pos) => {
  let theName = "";
  switch (pos) {
    case "north":
      theName = "Mon Potoss";
      break;
    case "east":
      theName = "Le Conard";
      break;
    case "south":
      theName = "Moi ";
      break;
    case "west":
      theName = "l'Enculé";
      break;
    default:
      theName = "error";
  }

  return theName;
};
